import { render, staticRenderFns } from "./en.vue?vue&type=template&id=ed373ce4&scoped=true&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"
import style0 from "./en.vue?vue&type=style&index=0&id=ed373ce4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed373ce4",
  null
  
)

export default component.exports